import { PhoneCall, ClipboardList, Hammer, BadgeCheck } from "lucide-react"
export default function Process() {
    return (
<div className="bg-blue-600 p-8 lg:p-12 max-w-[90%] xl:max-w-7xl mx-auto mx-auto">
  <div className="flex flex-col gap-4 mb-10">
  <div>
  <p className="text-blue-200 text-xs font-bold tracking-widest uppercase mb-3">
    Our Process
  </p>

  <h2 className="font-black text-white text-4xl lg:text-5xl tracking-tight leading-tight">
    Simple Steps<br />
    <span className="text-blue-200 font-light">
      From Call to Completion
    </span>
  </h2>
</div>

<p className="text-blue-100 text-lg leading-relaxed max-w-xl">
  A clear and straightforward process from your first contact to the final inspection, so you always know what to expect.
</p> 
  </div>

  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
    {[
      { icon: PhoneCall, title: "Call or contact us", desc: "We ask a few quick questions to understand the issue and get you scheduled fast." },
      { icon: ClipboardList, title: "Diagnosis & estimate", desc: "A licensed plumber arrives, assesses the issue, and gives you a clear upfront price." },
      { icon: Hammer, title: "Expert repair", desc: "We get to work immediately using professional tools, completing most jobs same visit." },
      { icon: BadgeCheck, title: "Quality sign-off", desc: "We test everything before leaving so you know the job is solid and done right." },
    ].map(({ icon: Icon, title, desc }, i) => (
      <div key={i} className="bg-white/10 hover:bg-white/15 transition-colors rounded-2xl p-6">
        <div className="flex items-center justify-between mb-5">
          <div className="w-10 h-10 bg-white/15 rounded-xl flex items-center justify-center">
            <Icon className="w-4.5 h-4.5 text-white" strokeWidth={2} />
          </div>
          <span className="text-3xl font-black text-white/10 leading-none select-none">
            {String(i + 1).padStart(2, "0")}
          </span>
        </div>
        <h3 className="font-bold text-white text-sm mb-2 leading-snug">{title}</h3>
        <p className="text-blue-200 text-xs leading-relaxed">{desc}</p>
      </div>
    ))}
  </div>
</div>
    )
}